import "./radio-v2.css";

import { FC } from "react";
import { twMerge } from "tailwind-merge";
import { RadioV2Type } from "./radio-v2.types";

export const RadioV2: FC<RadioV2Type> = ({
  label,
  onChange,
  className,
  checked,
}) => {
  return (
    <div className={twMerge("flex items-center", className)}>
      <div
        className="flex items-center"
        style={{ flexDirection: "row", gap: "8px", alignItems: "center" }}
      >
        <input
          type="radio"
          id={label}
          checked={checked}
          style={{
            display: "flex",
            width: "17px",
            height: "17px",
            alignItems: "center",
            gap: "10px",
            flexShrink: "0",
            marginTop: 0,
          }}
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.checked);
            }
          }}
        />
        <label
          htmlFor={label}
          style={{ margin: 0, marginBottom: "1px", cursor: "pointer" }}
        >
          {label}
        </label>
      </div>
    </div>
  );
};
